import { useDispatch } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { PLAN_STATUS } from 'app-constants'
import { AICard, InvoiceCardList } from 'components'
import { STATICS } from 'statics'
import { CTA_INFO } from './constants'
import './style.scss'

export function IneligibleContract({ data }) {
  const { detailedMessage, contractStatus, invoices } = data
  const ctaInfo = CTA_INFO[contractStatus]
  const dispatch = useDispatch()

  function handleCtaClick() {
    const { isCloseDrawer } = ctaInfo

    if (isCloseDrawer) dispatch(setDrawer(''))
  }

  function renderInvoices() {
    const isSuspended = contractStatus === PLAN_STATUS.ST_CONT_SUSP_DEBITO

    if (!isSuspended) return null

    return <InvoiceCardList items={invoices} />
  }

  function renderIcon() {
    return (
      <div className='icon'>
        <STATICS.INFO_TRIANGLE_FILLED />
      </div>
    )
  }

  return (
    <div className='support-ineligible-contract'>
      <AICard
        onCtaClick={handleCtaClick}
        ctaLabel={ctaInfo?.label}
        title={`Contrato ${contractStatus}`}
        message={detailedMessage}
        icon={renderIcon()}
      />
      {renderInvoices()}
    </div>
  )
}
